<template>
    <v-row>
        <v-col cols="8">
            <h3>{{ $t('pNl.title') }}</h3>
            <p>{{ $t('pNl.subtitle') }}</p>
            <apexchart :options="optionsPNLChart" :series="seriesPNLChart" height="350" type="area"/>
        </v-col>

        <v-col cols="4">
            <h3 class="d-flex justify-center">{{ $t('allocation.title') }}</h3>
            <p class="d-flex justify-center">{{ $t('allocation.subtitle') }}</p>
            <apexchart class="d-flex justify-center" width="420" type="donut" :options="optionsAssetDistribution" :series="seriesAssetDistribution"/>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: "PortfolioStats",
        data() {
            return {
                // Series
                seriesPNLChart: [],
                seriesAssetDistribution: [41, 42, 75],
                seriesEfficientFrontier: [
                    {
                        name: 'Bubble1',
                        data: this.generateData(new Date('11 Feb 2017 GMT').getTime(), 20, {
                            min: 10,
                            max: 60,
                        })
                    },
                    {
                        name: 'Bubble2',
                        data: this.generateData(new Date('11 Feb 2017 GMT').getTime(), 20, {
                            min: 10,
                            max: 60,
                        })
                    },],

                // Options
                optionsPNLChart: {
                    theme:{
                        mode:this.$store.state.currentTheme == "dark"? "dark": "light"
                    },
                    noData: {
                        text: 'No data for the current filter',
                        align: 'center',
                        verticalAlign: 'middle',
                        style: {
                            color: '#111111',
                            fontSize: '21px',
                            fontFamily: 'Ubuntu, sans-serif',
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'smooth',
                        colors: ['rgba(0, 247, 132, 1)']
                    },
                    fill: {
                        colors: ['rgba(0, 247, 132, 0.2)'],
                        opacity: 0.5,
                        type: 'solid',
                    },
                    xaxis: {
                        type: 'datetime',
                        axisBorder: {
                            show: false
                        },
                        axisTicks: {
                            show: false
                        },
                        labels:{
                            show:true,
                            style:{
                                color:"#000000"
                            },
                            color:"#FFFFFF",
                            fill:"#ffffff",
                            colors:["#FFFFFF"]
                        },
                        style:{
                                color:"#000000"
                            },
                            color:"#FFFFFF",
                            colors:["#FFFFFF"]
                    },
                    yaxis: {
                        tickAmount: 4,
                        floating: false,

                        labels: {
                            formatter: function (value) {
                              let numberValue = (Math.abs(value) >= 1000000)? `${Math.abs(value / 1000000).toFixed(1)}M` :
                                  (Math.abs(value) >= 1000)? `${Math.abs(value / 1000).toFixed(1)}k` : Math.abs(value.toFixed(0));
                              return (value >= 0)? `$${numberValue}` : `-$${numberValue}`;
                            },
                            style: {
                                color: '#6C7079',
                            },
                            offsetY: -7,
                            offsetX: 0,
                        },
                        axisBorder: {
                            show: false,
                        },
                        axisTicks: {
                            show: false
                        }
                    },
                    tooltip: {
                        x: {
                            format: "dd/MM/yyyy HH:mm",
                        },
                        fixed: {
                            enabled: false,
                            position: 'topRight'
                        }
                    },
                    grid: {
                        yaxis: {
                            lines: {
                                offsetX: -30
                            }
                        },
                        padding: {
                            left: 20
                        }
                    },
                },
                optionsAssetDistribution: {
                    theme:{
                        mode:this.$store.state.currentTheme == "dark"? "dark": "light"
                    },
                    noData: {
                        text: 'No data for the current filter',
                        align: 'center',
                        verticalAlign: 'middle',
                        style: {
                            color: '#111111',
                            fontSize: '21px',
                            fontFamily: 'Ubuntu, sans-serif',
                        }
                    },
                    chart: {
                        id: 'donutChart'
                    },
                    //colors:['rgba(0, 247, 132, 1)', 'rgb(0,179,247)', 'rgb(136,0,247)', 'rgb(208,0,247)'],
                    colors:['rgb(0,85,50)', 'rgb(36,120,81)', 'rgb(0,196,105)', 'rgba(0, 247, 132, 1)', '#95f9ca'],
                    labels: [],
                },
                optionsEfficientFrontier: {
                    dataLabels: {
                        enabled: false
                    },
                    colors:['rgba(0, 247, 132, 1)', 'rgb(0,179,247)', 'rgb(136,0,247)', 'rgb(208,0,247)'],
                    fill: {
                        opacity: 0.8
                    },
                    xaxis: {
                        tickAmount: 12,
                        type: 'category',
                    },
                    yaxis: {
                        max: 70
                    }
                },
            };
        },
        mounted() {
            this.setData();
        },
        watch: {
            '$store.state.book.trades': function() {
                this.setData();
            }
        },
        methods: {
            setData(){
                this.setPNLChart();
                //this.setEfficientFrontierChart();
                this.setAssetDistributionChart();
            },
            //For Demo
            setPNLChart() {
                let accumulativeProfit = 0;
                let newData = [];
                let copyOfTrades = this.$store.state.book.trades.slice();
                copyOfTrades.sort((tradeA, tradeB) => tradeA.openTime.getTime() - tradeB.openTime.getTime());

                copyOfTrades.forEach((trade) => {
                    // PNL chart
                    accumulativeProfit += trade.netProfit;
                    newData.push([trade.openTime.getTime(), accumulativeProfit]);
                });

                this.seriesPNLChart = [{
                    name: 'P&L',
                    data: newData,
                }];
            },
            setAssetDistributionChart(){
                let map = {};
                this.seriesAssetDistribution = [];
                let newLabels = [];

                let copyOfTrades = this.$store.state.book.trades.slice();
                copyOfTrades.forEach((trade) => {
                    if(!(trade.asset.ticker in map))
                        map[trade.asset.ticker] = 1;
                    else
                        map[trade.asset.ticker] = ((map[trade.asset.ticker] * 1) + 1);
                });

                for(let asset in map){
                    newLabels.push(asset);
                    this.seriesAssetDistribution.push(map[asset]);
                }

                this.optionsAssetDistribution = {
                    labels: newLabels,
                    chart: {
                        id: 'donutChart'
                    },
                    colors:['rgb(0,85,50)', 'rgb(36,120,81)', 'rgb(0,196,105)', 'rgba(0, 247, 132, 1)', '#95f9ca'],
                    tooltip: {
                        y: {
                            formatter: function(val) {
                                return `${val} trades`;
                            },
                            title: {
                                formatter: function (asset) {
                                    return asset;
                                }
                            }
                        }
                    },
                };
            },
            generateData(baseval, count, yrange) {
                var i = 0;
                var series = [];
                while (i < count) {
                    var x = Math.floor(Math.random() * (750 - 1 + 1)) + 1;
                    var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
                    var z = Math.floor(Math.random() * (75 - 15 + 1)) + 15;

                    series.push([x, y, z]);
                    baseval += 86400000;
                    i++;
                }
                return series;
            }
        }
    }
</script>

<i18n>
{
  "en": {
    "pNl": {
      "title": "Profit & Loss Chart",
      "subtitle": "How has my performance been over time (Balance)."
    },
    "allocation": {
      "title": "Portfolio Allocation",
      "subtitle": "How much do I trade each asset in my portfolio."
    }
  },
  "es": {
    "pNl": {
      "title": "Pérdidas/Ganancias del Portafolio",
      "subtitle": "Cómo ha sido mi rendimiento a lo largo del tiempo (Balance)."
    },
    "allocation": {
      "title": "Asignación del Portafolio",
      "subtitle": "Qué tanto opero cada activo de mi portafolio."
    }
  }
}
</i18n>

<style lang="scss">

</style>
